<template>
    <div class="collapse">
        <h5>已购买项目信息</h5>
        <div ref="top">
            <!-- :row-class-name="tableRowClassName" -->
            <el-table ref="table" :key="itemKey" @row-click="tab" max-height="200" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
                <el-table-column sortable prop="projectName" label="项目名称"></el-table-column>
                <el-table-column sortable prop="projectReplenish" label="项目补充"></el-table-column>
                <el-table-column sortable prop="createTime" label="订购日期"></el-table-column>
                <el-table-column sortable prop="purchaseNumber" label="订购次数"></el-table-column>
                <el-table-column sortable prop="projectAmt" label="价格"></el-table-column>
                <el-table-column :default-sort="{prop: 'residueNumber', order: 'descending'}" prop="residueNumber" label="剩余次数"></el-table-column>
                <el-table-column prop="musProjectReplenish" label="划扣补充"></el-table-column>
                <el-table-column sortable prop="remark" label="备注"></el-table-column>
                <el-table-column sortable prop="purchaseRemark" label="购买备注"></el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="counts.pagination.page" :page-size="counts.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="counts.pagination.total">
            </el-pagination>
        </div>
        <el-dialog center append-to-body title="确认划扣项目" :visible.sync="dialogVisible" width="30%">
            <el-form ref="form" :model="form" label-width="80px">
                <el-form-item label="活动名称">
                    <el-input disabled v-model="form.projectName"></el-input>
                </el-form-item>
                <el-form-item label="项目补充">
                    <el-input disabled v-model="form.projectReplenish"></el-input>
                </el-form-item>
                <el-form-item label="订购日期">
                    <el-input disabled v-model="form.createTime"></el-input>
                </el-form-item>
                <el-form-item label="订购次数">
                    <el-input disabled v-model="form.purchaseNumber"></el-input>
                </el-form-item>
                <el-form-item label="价格">
                    <el-input disabled v-model="form.projectAmt"></el-input>
                </el-form-item>
                <el-form-item label="剩余次数">
                    <el-input disabled v-model="form.residueNumber"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input disabled v-model="form.remark"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button :disabled="form.residueNumber=='0'?true:false" type="primary" @click="sure">划扣</el-button>
                <el-button :disabled="form.residueNumber=='0'?true:false" type="danger" @click="refund">退款</el-button>
                <!-- <el-button :disabled="form.residueNumber=='0'?true:false" type="primary" >转项目</el-button> -->
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { log } from 'util';
export default {
    props: ["aaData", "counts", "childData", "refundData", 'formData', 'rowId'],
    data() {
        return {
            tableData: this.aaData,
            s: [],
            v: [],
            dialogVisible: false,
            form: {},
            tabData: '',
            itemKey: '',
        };
    },
    watch: {
        aaData: {
            handler(newValue, oldValue) {
                // console.log(newValue);
                this.tableData = newValue
            },
            immediate: true,
            deep: true,
        },
        refundData: {
            deep: true, // 深度监听每一个属性值, 如果是对象可以深度监听
            immediate: true, // 进入页面后立即自动调用handler函数
            handler(newValue) {
                // console.log(newValue);
                return newValue;
            }
        },
    },
    created() {
        busPhone.$on('list', val => { // 接收值
            // console.log(val);
            if (this.tableData.length == 0) {
                this.tableData = JSON.parse(JSON.stringify(val))
            } else if (this.tableData.length != 0) {
                this.s = this.tableData.map(x => x.purchaseId)
                val.forEach(item => {
                    if (!this.s.includes(item.purchaseId)) {
                        this.tableData.push(item)
                    } else if (this.s.includes(item.purchaseId)) {
                        // 解决数据更新，el-table表格不更新
                        this.itemKey = Math.random()
                        // 如果有重复数据，替换当前数据
                        this.tableData.splice(this.tableData.findIndex(list => list.purchaseId === item.purchaseId), 1, item);
                    }
                });
            }
            // // 动态修改分页总条数
            this.counts.pagination.total = this.tableData.length
            // 添加数据后表格排序
            // console.log(this.$refs.table);
            this.tableData.sort(this.compare('residueNumber'))
        })
        busPhone.$on('tableId', val => { // 接收值
            let index = this.tableData.findIndex(item => item.purchaseId === val)
            if (index != -1) {
                this.tableData.splice(index, 1);
            }
            // 动态修改分页总条数
            this.counts.pagination.total = this.tableData.length
        })
    },
    methods: {
        // 数值排序
        compare(property) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                return value2 - value1;
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        pageChanged(page) {
            this.counts.pagination.page = page;
            this.$emit('getProject', this.counts.pagination.page, this.formData.mobile, this.formData.id);
        },
        handleSizeChange(sizes) {
            this.counts.pagination.limit = sizes;
        },
        tab(val) {
            // console.log('val');
            // console.log(val);
            this.dialogVisible = true
            this.form = val
            this.tabData = JSON.parse(JSON.stringify(this.form))
            // console.log('this.tabData');
            // console.log(this.tabData);

        },
        // 点击确定时把当前条给划扣项目
        sure() {
            console.log('this.tabData');
            console.log(this.tabData);
            this.tabData.musProjectId = parseInt(this.tabData.projectId)//项目id
            this.tabData.musProjectName = this.tabData.projectName//项目名称
            this.tabData.musReplenish = this.tabData.projectReplenish//项目补充
            this.tabData.musContent = 1//划扣次数默认为1
            this.tabData.unitPrice = this.tabData.projectAmt / this.tabData.purchaseNumber//项目单价
            this.tabData.materialList = []
            // console.log('this.childData');
            // console.log(this.childData);
            // let sum = this.childData.reduce(function (prev, cur) {
            //     return prev + cur.musContent;
            // }, 1);
            // // console.log('总的划扣次数sum');
            // // console.log(sum);
            // // if (this.tabData.rnCount < 0) {
            // //     _g.toast("warning", '当前购买项目已无划扣次数');
            // //     return;
            // // } else {
            // this.tabData.amt = this.childData.reduce(function (prev, cur) {
            //     return prev + Number(cur.musAmt);
            // }, 0);
            // this.tabData.musAmt = this.tabData.projectAmt - this.tabData.amt//当日划扣金额
            // // console.log('当前划扣金额');
            // // console.log(this.tabData.musAmt);
            // this.tabData.rnCount = this.tabData.residueNumber - sum
            // console.log('当前项目剩余次数');
            console.log('this.tabData');
            console.log(this.tabData);
            this.childData.push(this.tabData)
            console.log('this.childData');
            console.log(this.childData);
            // }
            // this.childData.push(this.tabData)
            this.dialogVisible = false
            // console.log('this.tabData.rnCount');
            // console.log(this.tabData.rnCount);

        },
        // 点击确定时把当前条给退款项目
        refund() {
            console.log(this.refundData);
            // 如果暂无划扣项目直接push如果有进行判断
            if (this.refundData.length == 0) {
                this.tabData.refundProjectId = parseInt(this.tabData.projectId)//退款项目id
                this.tabData.refundProjectName = this.tabData.projectName//退款项目名称
                this.tabData.refundReplenish = this.tabData.projectReplenish//退款项目补充
                this.tabData.unitPrice = this.tabData.projectAmt / this.tabData.purchaseNumber//项目单价
                this.tabData.refundContent = 1//退款次数默认为1
                this.tabData.refundCount = this.tabData.residueNumber - this.tabData.refundContent
                this.refundData.push(this.tabData)
            } else if (this.refundData.length != 0) {
                this.refundData.forEach(item => {
                    this.v = this.refundData.map(x => x.purchaseId)
                    if (!this.v.includes(this.tabData.purchaseId)) {
                        this.tabData.refundProjectId = parseInt(this.tabData.projectId)//退款项目id
                        this.tabData.refundProjectName = this.tabData.projectName//退款项目名称
                        this.tabData.refundReplenish = this.tabData.projectReplenish//退款项目补充
                        this.tabData.unitPrice = this.tabData.projectAmt / this.tabData.purchaseNumber//项目单价
                        this.tabData.refundContent = 1//划扣次数默认为1
                        this.tabData.refundCount = this.tabData.residueNumber - this.tabData.refundContent
                        this.refundData.push(this.tabData)
                    }
                });
            }
            this.dialogVisible = false
        },
    },
};
</script>
<style scoped>
.el-table >>> .warmRed {
  color: rgb(184, 18, 18);
}

.collapse >>> .el-collapse-item__header {
  background: #fecaca !important;
  padding-left: 10px;
  font-weight: bold;
  font-size: 16px;
}

.collapse >>> .el-collapse-item__content {
  padding: 10px 0 !important;
}

.collapse >>> .el-form-item {
  margin-bottom: 8px !important;
}
</style>
